import dayjs from "@eisox/dayjs";
import { createContext } from "@radix-ui/react-context";

/* -------------------------------------------------------------------------------------------------
 * Context
 * -----------------------------------------------------------------------------------------------*/

type Locale = "fr" | "en";

const LOCALE_NAME = "Locale";

interface LocaleContextValue {
  locale: Locale | null;
}

const [LocaleContextProvider, useLocaleContext] = createContext<LocaleContextValue>(LOCALE_NAME, { locale: null });

const normalizeLocale = (locale: string): Locale => (locale.toLowerCase().startsWith("fr") ? "fr" : "en");

/* -------------------------------------------------------------------------------------------------
 * LocaleProvider
 * -----------------------------------------------------------------------------------------------*/

interface LocaleProviderProps {
  locale: string;
  children?: React.ReactNode;
}

const LocaleProvider = ({ locale, children }: LocaleProviderProps) => (
  <LocaleContextProvider locale={normalizeLocale(locale)}>{children}</LocaleContextProvider>
);

LocaleProvider.displayName = LOCALE_NAME;

/* -------------------------------------------------------------------------------------------------
 * useLocale
 * -----------------------------------------------------------------------------------------------*/

const useLocale = (): Locale => useLocaleContext(LOCALE_NAME).locale ?? normalizeLocale(dayjs.locale());

export { LocaleProvider, useLocale };
export type { Locale, LocaleProviderProps };
